import { render, staticRenderFns } from "./StageContent.vue?vue&type=template&id=f7a3bc9a&"
import script from "./StageContent.vue?vue&type=script&lang=ts&"
export * from "./StageContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports